import moment from 'moment';

import axiosInstance from 'mf-shared/utils/axiosInstance';
import { login } from 'mf-shared/utils/auth';
import { GOID_SERVICE } from 'api/constants';

export async function getAuthType(email, phoneNumber) {
  // GoAuth/GoID is only available for staging and prod
  if (!process.env.MOKA_GOAUTH_SERVICE) {
    return {
      data: {
        authentication: 'MokaAuth-username',
      },
    };
  }

  return axiosInstance.post('/mkGoAuth/account/v1/map/users/verify', {
    email,
    phone_number: phoneNumber,
    accept_authentication: ['GoAuth-email', 'MokaAuth-username'],
  });
}

export async function loginGoAuth(email, password) {
  try {
    const { data } = await axiosInstance.post(
      `${GOID_SERVICE}/gobiz/goauth/oauth2/token`,
      {
        grant_type: 'password',
        username: email,
        password,
        client_id: 'moka-pos-web',
        scope: 'offline',
      },
      {
        headers: {
          'Authentication-Type': 'go-id',
        },
      }
    );

    const {
      access_token: accessToken,
      refresh_token: refreshToken,
      expires_in: expiresIn,
    } = data;

    const expiry = moment().add(expiresIn, 'seconds').toISOString();

    return {
      accessToken,
      refreshToken,
      expiry,
    };
  } catch (error) {
    if (error?.response?.data?.error_description) {
      const { error_description, error_hint } = error.response.data;
      let message = error_description;

      if (error_hint) {
        message += `: ${error_hint}`;
      }

      throw new Error(message);
    }
    throw error;
  }
}

export async function loginMoka(email, phone, password) {
  try {
    const { data } = await login(email, password, phone);

    const {
      access_token: accessToken,
      refresh_token: refreshToken,
      access_token_exp: expiry,
    } = data;

    return {
      accessToken,
      refreshToken,
      expiry,
    };
  } catch (error) {
    if (error?.response?.data?.error?.user_message) {
      throw new Error(error.response.data.error.user_message);
    }
    throw error;
  }
}

export function completeUserAssociationApi() {
  return axiosInstance.post(
    '/mkGoAuth/account/v1/map/users/notification/disable'
  );
}
